"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const polished_1 = require("polished");
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const button_1 = __importDefault(require("./button"));
const button_group_1 = require("./button-group");
const paddings = {
    small: 6,
    medium: 10,
    large: 14,
};
function paddingStyle(size, borderWidth, { spacing }) {
    return {
        padding: `${(0, polished_1.math)(`${spacing(paddings[size])} - ${borderWidth}`)}`,
    };
}
const useStyles = (0, create_use_styles_1.default)(theme => ({
    button: ({ round, size }) => (0, lodash_merge_1.default)({
        borderRadius: round ? "100%" : undefined,
    }, paddingStyle(size, theme.size(1), theme)),
}));
exports.IconButton = react_1.default.forwardRef(function IconButton({ className, icon, round, size = "medium", ...props }, ref) {
    const buttonGroupProps = (0, react_1.useContext)(button_group_1.ButtonGroupContext);
    const classes = useStyles({ round, size: buttonGroupProps.size || size });
    return react_1.default.createElement(button_1.default, { ref: ref, className: (0, classnames_1.default)(classes.button, className), icon: icon, size: size, ...props });
});
exports.default = exports.IconButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbi1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2J1dHRvbi9pY29uLWJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQ0FBMEM7QUFDMUMsNERBQW9DO0FBQ3BDLGdFQUFpQztBQUNqQyx1Q0FBZ0M7QUFJaEMsd0ZBQThEO0FBRzlELHNEQUE4QjtBQUM5QixpREFBb0Q7QUFZcEQsTUFBTSxRQUFRLEdBQWdDO0lBQzVDLEtBQUssRUFBRSxDQUFDO0lBQ1IsTUFBTSxFQUFFLEVBQUU7SUFDVixLQUFLLEVBQUUsRUFBRTtDQUNWLENBQUM7QUFFRixTQUFTLFlBQVksQ0FBQyxJQUFpQixFQUFFLFdBQW1CLEVBQUUsRUFBRSxPQUFPLEVBQVM7SUFDOUUsT0FBTztRQUNMLE9BQU8sRUFBRSxHQUFHLElBQUEsZUFBSSxFQUFDLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLFdBQVcsRUFBRSxDQUFDLEVBQUU7S0FDbEUsQ0FBQztBQUNKLENBQUM7QUFFRCxNQUFNLFNBQVMsR0FBRyxJQUFBLDJCQUFlLEVBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQzFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBb0IsRUFBRSxFQUFFLENBQzVDLElBQUEsc0JBQUssRUFDSDtRQUNFLFlBQVksRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsU0FBUztLQUN6QyxFQUNELFlBQVksQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FDekM7Q0FDSixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsVUFBVSxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQXFDLFNBQVMsVUFBVSxDQUFDLEVBQUUsU0FBUyxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsSUFBSSxHQUFHLFFBQVEsRUFBRSxHQUFHLEtBQUssRUFBRSxFQUFFLEdBQUc7SUFDM0osTUFBTSxnQkFBZ0IsR0FBRyxJQUFBLGtCQUFVLEVBQUMsaUNBQWtCLENBQUMsQ0FBQztJQUN4RCxNQUFNLE9BQU8sR0FBRyxTQUFTLENBQUMsRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLGdCQUFnQixDQUFDLElBQUksSUFBSSxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBRTFFLE9BQU8sOEJBQUMsZ0JBQU0sSUFBQyxHQUFHLEVBQUUsR0FBRyxFQUFFLFNBQVMsRUFBRSxJQUFBLG9CQUFVLEVBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEtBQU0sS0FBSyxHQUFJLENBQUM7QUFDbkgsQ0FBQyxDQUFDLENBQUM7QUFFSCxrQkFBZSxrQkFBVSxDQUFDIn0=